<template>
  <div>
    <div class="localdiv tright pr15 tc6 pt35 pb15">
      <span class="fs24 fl tc3 lborder prelative pl25 lh10">{{menu[pid]['children'][id]['name']}}</span>
      <div class="pt10">
        当前位置:
        <router-link to="/">学校首页 > </router-link>
        <span>{{menu[pid]['name']}} > </span>
        <router-link :to="{path:'/evn/list',query:{pid:pid,id:id}}">{{menu[pid]['children'][id]['name']}}</router-link>
      </div>
    </div>
    <div class="cont tleft pt50 pb30">
      <div class="media mb15 tleft prelative cpointer fs16 ofhidden" @click="goContent(item.id,index)" v-for="(item,index) in list" :key="item.id">
        {{item.title}}
        <div class="date pabsolute tc-red">
          （{{item.created_at}}）
        </div>
      </div>
    </div>
    <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="id+pid"/>
  </div>
</template>

<script>
import Pagec from "./Page";
export default {
  name: "ListFile",
  props:[
    'id',
    'pid',
    'list',
    'total',
    'menu',
    'page',
    'perPage',
    'getData',
  ],
  components:{
    Pagec
  },

  methods:{
    goContent(id,index){
      var routeQuery = this.$route.query;
      var query = {
        article_id:id,
        num:(this.page - 1) * this.perPage + index + 1,
        pid:routeQuery.pid,
        id:routeQuery.id,
      }
      this.$router.push({path:'/evn/dfile',query:query})
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/un_index/ListFile.vue